<style lang="less" scoped>
.center{width: 100%;display: flex;flex-direction: column;background: #fff;position: relative;}
.expert{width: 1200px;margin: 20px auto;display: flex;justify-content:space-between;}
.expert_left{
  ul{list-style: none;margin: 0;padding: 0;}
  .imgTitleContent{text-align: left;}
}
.el-button{width: 780px;font-size: 16px;background-image: linear-gradient(#ECFAFF, #ECF6FF);margin-top: 10px;}
i{font-size: 19px;color: #289FDE;margin-right: 5px;}
h3{line-height: 50px;text-align: left;margin:0;font-size: 18px;}
.expert_rig{margin-right: 150px;
  .country{ position: relative;
    ul{list-style: none;margin: 0;padding: 0;}
    .left{position: absolute;left: 90px;top: -8px;
      li{margin: 7px auto;cursor: pointer;}
      img{width: 240px;height: 158px;}
    }
    .right{margin-left: 20px;text-align: left;position: absolute;left: 90px;top: -8px;
      li{width: 280px;height: 38px;border-bottom: 2px solid rgb(230, 228, 228);margin: 10px auto;cursor: pointer;}
      span{font-size: 18px;letter-spacing: 1px;}
      .zhuanjia{font-weight: 600;}
    }
  }
}
</style>

<template>
  <div class="center">
    <div class="expert">
      <div class="expert_left">
        <h3><i class="iconfont icon-fenlei_"></i>常见问题 / Common Problem</h3>
        <ul>
          <li v-for="(item,index) in items" :key="index" >
            <ZJImgTitleContent class="imgTitleContent" :imgTitleContentItem="item" ></ZJImgTitleContent>
          </li>
        </ul>
        <el-button @click="getOthers" :disabled="moreLength <= 0">加载更多</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ZJImgTitleContent from '../assembly/ZJImgTitleContent.vue'
export default {
  components: {ZJImgTitleContent},
  name: '',
  data()
  {
    return {
      temp: [],
      nameList: [],
      expertlist: [],
      num: null,
      items: [],
      moreLength: null,
      currentPage: 1
    }
  },
  created()
  {
    this.getdata()
    this.getExpertlist(2)
  },
  methods:
  {
    getdata(catid)
    {
      //获取列表数据
      let paras = {cmd: 'query', _major: 11, _minor: 125, _exp: 'id>0 and type = 3', orderby: 'id ASC', init: 0, pageno: `${this.currentPage}`, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        ret[0].data.forEach(item =>
        {
          arr.push({id: item.id, pic: item.thumb ? item.thumb : 'static/images/moren.jpg', title: item.question, introduce: item.answer, release: '发布时间', time: item.addtime, description: '关键词', value: item.tag})
        })
        this.imgTitleContentdata = arr
        this.moreLength = this.imgTitleContentdata.length
        // 初始化页面数据
        this.items = []
        if (this.imgTitleContentdata.length >= 10)
        {
          for (let i = 0; i < 10; i++)
          {
            this.items.push(this.imgTitleContentdata[i])
            this.moreLength -= 1
          }
        }
        else
        {
          for (let i = 0; i < this.imgTitleContentdata.length; i++)
          {
            this.items.push(this.imgTitleContentdata[i])
            this.moreLength -= 1
          }
        }
        this.num = 0
      })
    },
    getOthers()
    {
      this.currentPage++
      this.getdata()
    },
    /**
     * 获取专家列表
     */
    getExpertlist(num)
    {
      //获取作者名字
      let paras2 = {cmd: 'query', _major: 11, _minor: 28, _exp: `areaid=${num}`, orderby: 'id ASC', init: 0, pageno: 1, pagesize: 100}
      window.post.getPost(paras2).then(ret =>
      {
        this.nameList = []
        ret[0].data.forEach(item =>
        {
          this.nameList.push({id: item.id, truename: item.truename})
        })
      })
    },
    goZjDetails(item)
    {
      let url = this.$router.resolve({path: '/ZjDetails', query: { id: item.id }})
      window.open(url.href, '_blank')
    },
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/ZhikuDetails', query: { id: item.id }})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/CjwtList.vue